import axiosInstance from '../../../../lib/axios';
import type {
  PaymentDetail,
  PaymentListParams,
  PaymentListResult,
  ReconcileResult,
} from '../types';

const BASE = '/v1/admin/payments';

export const listPayments = async (params: PaymentListParams) => {
  const response = await axiosInstance.get<{ data: PaymentListResult }>(BASE, {
    params: {
      ...params,
      status: params.status || undefined,
      kind: params.kind || undefined,
      q: params.q || undefined,
      from: params.from || undefined,
      to: params.to || undefined,
    },
  });
  return response.data.data;
};

export const getPayment = async (publicId: string) => {
  const response = await axiosInstance.get<{ data: PaymentDetail }>(`${BASE}/${publicId}`);
  return response.data.data;
};

export const reconcilePayment = async (publicId: string) => {
  const response = await axiosInstance.post<{ data: ReconcileResult }>(
    `${BASE}/${publicId}/reconcile`
  );
  return response.data.data;
};
